<template>
  <c-box
    v-if="attributes"
    :mb="{ base: 'md', sm: '4xl' }"
    v-chakra="{
      '.product-file-row': {
        borderBottom: '1px solid var(--chakra-colors-brand-purpleLight)',
        '&:last-child': { borderBottom: 'none' },
      },
    }"
  >
    <c-heading
      as="h4"
      :fontSize="{ base: 'md', sm: '2xl' }"
      :fontWeight="{ base: 700, sm: 400 }"
      :mb="{ base: 'md', sm: '2xl' }"
      >{{ label }}</c-heading
    >
    <c-box :my="{ base: 0, sm: '3xl' }">
      <ProductFileRow
        v-for="attribute in attributes"
        :key="attribute.id"
        :preferred-locale="userLocale()"
        :attribute="attribute"
        class="product-file-row"
      />
    </c-box>
  </c-box>
</template>

<script lang="ts">
import { CBox, CHeading, CText } from "@chakra-ui/vue";
import { IProductAttribute, IUser, IRootState } from "@iloq/shared";
import { defineComponent, PropType } from "vue";
import { mapState } from "vuex";
import ProductFileRow from "./ProductFileRow.vue";

export default defineComponent({
  name: "ProductFileGroup",
  components: {
    ProductFileRow,
    CText,
    CBox,
    CHeading,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attributes: {
      type: Array as PropType<IProductAttribute[]>,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      user: (state: unknown) => (state as IRootState).user,
    }),
  },
  methods: {
    userLocale(): string {
      const user = this.user as IUser;
      return `${user.languageCode}_${user.countryCode.toUpperCase()}`;
    },
  },
});
</script>
